export { SysquePropertiesListModule } from './sysque-properties-list.module';
export { SysquePropertiesListComponent } from './sysque-properties-list.component';